<template>
    <div class="modal fade fade-scale modal-wrapper" id="subscribe-modal" role="dialog"
         aria-labelledby="subscribe-modal-label" aria-hidden="false">
        <div class="alert-wide modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="row">
                        <div class="swal2-icon d-flex swal2-info justify-content-center">
                            <div class="swal2-icon-content">
                                <i class="fas fa-plane"></i>
                            </div>
                        </div>
                    </div>

                    <div class="row flex-column">
                        <h3 v-if="userHasPhone" class="m-5 text-center">{{ getPopUpTitle('pre-join-modal-user-with-phone') }}</h3>
                        <h3 v-if="!userHasPhone" class="m-5 text-center">{{ getPopUpTitle('pre-join-modal-user-without-phone') }}</h3>
                        <div class="row ml-auto mr-auto mt-20 mb-20"> 
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/mlK1DKs6j-c" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                        <div v-if="userHasPhone" class="test" v-html="getPopUpBody('pre-join-modal-user-with-phone')"></div>
                        <div v-if="userHasPhone && !updatePhone" class="test">
                            <p>We have your telephone number as {{ currentUserPhone }}, if you need to change it, click here: 
                                <button class="btn btn-primary btn-update-phone" @click="displayTelephoneInput" > <i class="fas fa-phone-square-alt"></i></button> </p>
                        </div>
                        <div v-if="!userHasPhone" class="test" v-html="getPopUpBody('pre-join-modal-user-without-phone')"></div>
                    </div>

                     <ValidationObserver v-slot="{ dirty, invalid }">
                        <div class="row">

                            <div v-show="Boolean(userHasPhone && updatePhone) || userHasPhone == false " class="col-12 mt-5">
                                <ValidationProvider name="Phone" rules="phoneRestrictionNullable" v-slot="{ errors } " >

                                    <div class="input-group mb-3 d-flex flex-row align-items-baseline">
                                        <div class="col-4 p-0 align-self-center">
                                            <label v-if="userHasPhone" for="phone">Please update your phone number: </label>
                                            <label v-if="!userHasPhone" for="phone">Please enter your phone number: </label>
                                        </div>
                                        <div class="col-8">
                                            <input v-model="phone" type="text" class="form-control"
                                               placeholder="Enter your phone" aria-label="Guest phone" v-mask="'(###) ###-####'">
                                            <div class="invalid-feedback">{{errors[0]}}</div>
                                        </div>
                                    </div>
                                </ValidationProvider>
                            </div>

                            <div class="mt-10" v-html="getPopUpBody('pre-join-modal-footer')"></div>

                            <div class="col-12 text-center m-5 p-5">
                                <button id="guest-user-subscription" class="btn btn-light-blue mx-5" @click="okButtonClicked" type="button"
                                        :disabled="invalid">
                                    OK
                                </button>
<!--                                 <button id="guest-user-subscription-reject" class="btn btn-secondary mx-5" @click="close" type="button">
                                    Close 
                                </button> -->
                            </div>
                        </div>
                    </ValidationObserver>

                    <!-- <ValidationObserver v-slot="{ dirty, invalid }">
                        <div class="row">
                            <div class="col-12 mt-5">
                                <ValidationProvider name="Phone" rules="phoneRestriction" v-slot="{ errors } " >
                                    <div class="input-group mb-3">
                                        <input v-model="phone" type="text" class="form-control"
                                               placeholder="Enter your phone" aria-label="Guest phone" v-mask="'(###) ###-####'">
                                    </div>
                                    <div class="invalid-feedback">{{errors[0]}}</div>
                                </ValidationProvider>
                            </div>

                            <div class="col-12 mt-7">
                                <div class="invalid-feedback">{{message}}</div>
                            </div>

                            <div class="col-12 text-center m-5 p-5">
                                <button id="guest-user-subscription" class="btn btn-light-blue mx-5" @click="subscribe" type="button"
                                        :disabled="invalid || !dirty">
                                    Save
                                </button>
                                <button id="guest-user-subscription-reject" class="btn btn-secondary mx-5" @click="exit" type="button">
                                    Exit
                                </button>
                            </div>
                        </div>
                    </ValidationObserver> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // import httpClient from '@/utils/httpClient';
    // import axios from 'axios';
    import { mapState } from "vuex";
    import PopUpMixin from '@/mixins/dinamicPopUpMixin';
    // import func from '../../../vue-temp/vue-editor-bridge';

    export default {
        mixins:[PopUpMixin],
        data() {
            return {
                updatePhone:false,
                phone:null,
                message:null,
            }
        },
        mounted() {
            if (this.user == null) {
                this.$emit('userNotSetted')
            }
            else {
                this.phone = this.user.phone
            }
        },
        methods: {
            displayTelephoneInput() {
                this.phone = this.user.phone
                this.updatePhone = true
            },
            okButtonClicked() {
                if (!(this.phone == this.currentUserPhone)) {
                    this.$emit('phoneUpdated', this.phone)
                }
                this.$emit('close')    
            }
        },
        computed: {
            userHasPhone: function () {
                return Boolean(this.user && this.user.phone) 
            },
            currentUserPhone: function() {
                return this.userHasPhone ? this.user.phone : null
            },
            ...mapState('users', {
            user: state => state.user
            }),
        },
        watch: {
            currentUserPhone:function(val) {
                if (val) {
                    this.phone = val    
                }
            }
        }
    }
</script>

<style scoped>
    #subscribe-modal {
        background: rgba(0, 0, 0, 0.45);
    }

    #subscribe-modal.fade:not(.show) {
        opacity: 1;
        display: block;
    }

    .blink {
        animation: blink-animation 1s steps(5, start) infinite;
        -webkit-animation: blink-animation 1s steps(5, start) infinite;
    }

    @keyframes blink-animation {
        to {
            visibility: hidden;
        }
    }

    @-webkit-keyframes blink-animation {
        to {
            visibility: hidden;
        }
    }

    .alert-wide {
        max-width: 950px !important;
    }

    .swal2-icon {
        padding: .1em .2em .3em;
    }

    /*.swal2-icon.swal2-info {*/
    /*    border-color: #3fc3ee;*/
    /*    color: #3fc3ee;*/
    /*}*/
    .swal2-icon .swal2-icon-content {
        display: flex;
        align-items: center;
        font-size: 3.75em;
    }

    div.modal-content {
        border: none;
        /*border-radius: 10px;*/
    }

    div.modal-body {
        padding: 15px 45px;
    }

    .btn-login {
        cursor: pointer;
        font-size: 80%;
        font-weight: 400;
        font-family: sans-serif;
    }

    .btn-update-phone {
        padding: 1px 13px;
    }

    @media (max-width: 600px) {
        #subscribe-modal .modal-content {
        max-height: 600px;
        overflow: scroll;
        }
    }
</style>
